import React from 'react'
import styled, { css } from 'styled-components'

export type SwipeActionVariant = 'delete' | 'edit'
export type SwipeActionAlign = 'start' | 'end'

export interface SwipeActionProps {
  variant?: SwipeActionVariant
  align?: SwipeActionAlign
  icon?: React.ReactNode
  label?: React.ReactNode
  className?: string
}

export const SwipeAction: React.FC<SwipeActionProps> = ({
  variant = 'delete',
  align = 'end',
  icon,
  label,
  className,
}) => (
  <Root $variant={variant} $align={align} className={className}>
    {icon && <Icon aria-hidden>{icon}</Icon>}
    {label && <Label>{label}</Label>}
  </Root>
)

export default SwipeAction

const Root = styled.div<{
  $variant: SwipeActionVariant
  $align: SwipeActionAlign
}>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1.25rem;
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: ${({ theme }) => theme.text.lg};
  font-weight: 600;
  letter-spacing: 0.01em;
  user-select: none;
  direction: ltr;
  justify-content: ${({ $align }) =>
    $align === 'start' ? 'flex-start' : 'flex-end'};

  ${({ $variant, theme }) =>
    $variant === 'delete'
      ? css`
          background: ${theme.colors.danger};
          color: #ffffff;
        `
      : css`
          background: ${theme.colors.accent};
          color: ${theme.colors.ink};
        `}

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0 0.875rem;
    font-size: ${({ theme }) => theme.textMobile.lg};
  }
`

const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;

  svg {
    width: 100%;
    height: 100%;
  }
`

const Label = styled.span`
  line-height: 1;
`
